import React from "react";
import css from "./CoachMark.module.scss";
import { coachmark_pin, pointer } from "../../Images/Icons";
import { NavLink } from "react-router-dom";
const CoachMarkStep6 = (props) => {
    return (
        <div style={{ position: "relative" }}>
            <div className={css.backdrop}>
                <div className={css.higlight6}>
                    <div className={css.point}>
                        <img src={coachmark_pin}/>
                    </div>
                    
                    <div className={css.content}>                    
                        <i class="fi fi-rr-cross-small"></i>
                        <div className={css.title}>📊 Explore Daily Statistics!</div>
                        <div className={css.desc}>This section provides valuable data on today's yield energy, revenue generated, consumption, and energy consumed from your PV system. Let's maximize your energy efficiency every day! </div>
                        <div className={css.step}>6/10</div>
                        <NavLink to="/home" onClick={props.prev}>
                            <button className={css.prev}>Previous</button>
                        </NavLink>
                        <NavLink to="/home" onClick={props.next}>
                        <button className={css.next} onClick={props.scroll}>Next</button>
                        </NavLink>
                        
                    </div>
                </div>
                
            </div>
        </div>
    );
};

export default CoachMarkStep6;
